<script setup lang="ts">
import { Button } from '~/components/ui/button'

interface Option {
    name: string,
    documentId: string,
    [key: string]: any
}

const modelValue = defineModel<(string|number|null)>('modelValue', {
    default: null
})

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    icon: {
        type: String,
    },
    options: {
        type: Array as PropType<Option[]>,
        required: true,
    },
    btn_class: {
        type: String,
        default: null
    },
    optionLabel: {
        type: String,
        default: 'name'
    },
    optionValue: {
        type: String,
        default: 'documentId'
    },
})

const selectedOption = ref<(string|number|null)>(null)
function handleChange(option: Option) {
    if(selectedOption.value === option[props.optionValue]){
        selectedOption.value = null
    } else {
        selectedOption.value = option[props.optionValue]
    }
    modelValue.value = selectedOption.value
}

onMounted(() => {
    selectedOption.value = modelValue.value
})
</script>

<template>
    <div>
        <p class="text-lg font-bold mb-2">{{label}}</p>
        <div class="flex flex-wrap gap-2">
            <Button
                v-for="option in options"
                variant="lighter"
                size="sm"
                @click="handleChange(option)"
                class="text-black font-normal gap-1 text-xs py-1 px-2 h-auto"
                :class="{
                    'bg-primary-500 text-white': selectedOption === option[optionValue],
                }"
                >
                <span>{{option[optionLabel]}}</span>
                <Icon v-if="selectedOption === option[optionValue]" name="ri:check-line" />
            </Button>
        </div>
    </div>
</template>